import axios from 'axios';

export const base64prefix = () => {
  return `data:image/webp;base64,`;
};

export const getSuffixBase64 = (base64: string) => {
  if (!base64.startsWith('data:image')) return '';
  const suffix = base64.split(';')[0].split('/')[1];
  return suffix;
};

export const base64ToBlob = (base64: string) => {
  const binary = window.atob(base64.split(',')[1]);
  const len = binary.length;
  const buffer = new ArrayBuffer(len);
  const view = new Uint8Array(buffer);
  for (let i = 0; i < len; i++) {
    view[i] = binary.charCodeAt(i);
  }
  const suffix = getSuffixBase64(base64);
  const type = `image/${suffix}`;
  const blob = new Blob([view], { type });
  return blob;
};

export const urlToBase64 = (url: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, { responseType: 'blob' })
      .then((res) => {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result as string);
        };
        reader.readAsDataURL(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
